import { IUserDocuments } from '../models/users/user.interface'

export interface DisciplineMembershipField {
  key: string
  label: string
  icon: string
  category: 'English' | 'Western' | 'Rodeo' | 'College' | 'Other'
}

const IMG_PATH = '/assets/images/logos/'

export const DISCIPLINE_MEMBERSHIP_FIELDS: DisciplineMembershipField[] = [
  // English discipline numbers
  { key: 'ACPS', label: 'ACPS number', icon: IMG_PATH + 'ACPS-logo.png', category: 'English' },
  { key: 'AHA', label: 'AHA number', icon: IMG_PATH + 'AHA-logo.png', category: 'English' },
  { key: 'AHHS', label: 'AHHS number', icon: IMG_PATH + 'AHHS-logo.png', category: 'English' },
  { key: 'AMHA', label: 'AMHA number', icon: IMG_PATH + 'AMHA-logo.png', category: 'English' },
  { key: 'ARHPA', label: 'ARHPA number', icon: IMG_PATH + 'ARHPA-logo.png', category: 'English' },
  { key: 'ASHA', label: 'ASHA number', icon: IMG_PATH + 'ASHA-logo.png', category: 'English' },
  { key: 'EVUSA', label: 'EVUSA number', icon: IMG_PATH + 'EVUSA-logo.png', category: 'English' },
  { key: 'FEI', label: 'FEI number', icon: IMG_PATH + 'FEI-logo.png', category: 'English' },
  { key: 'IALHA', label: 'IALHA number', icon: IMG_PATH + 'IALHA-logo.png', category: 'English' },
  { key: 'IFSHA', label: 'IFSHA number', icon: IMG_PATH + 'IFSHA-logo.png', category: 'English' },
  { key: 'NSHR', label: 'NSHR number', icon: IMG_PATH + 'NSHR-logo.png', category: 'English' },
  { key: 'PFHA', label: 'PFHA number', icon: IMG_PATH + 'PFHA-logo.png', category: 'English' },
  { key: 'UPHA', label: 'UPHA number', icon: IMG_PATH + 'UPHA-logo.png', category: 'English' },
  { key: 'USDF', label: 'USDF number', icon: IMG_PATH + 'USDF-logo.png', category: 'English' },
  { key: 'USEA', label: 'USEA number', icon: IMG_PATH + 'USEA-logo.png', category: 'English' },
  { key: 'USEF', label: 'USEF number', icon: IMG_PATH + 'USEF-logo.png', category: 'English' },
  { key: 'USHJA', label: 'USHJA number', icon: IMG_PATH + 'USHJA-logo.png', category: 'English' },
  { key: 'WDAA', label: 'WDAA number', icon: IMG_PATH + 'WDAA-logo.png', category: 'English' },
  { key: 'WPCSA', label: 'WPCSA number', icon: IMG_PATH + 'WPCSA-logo.png', category: 'English' },
  { key: 'USTA', label: 'USTA number', icon: IMG_PATH + 'USTA-logo.png', category: 'English' },
  { key: 'EC', label: 'EC number', icon: IMG_PATH + 'EC-logo.png', category: 'English' },

  // Western discipline numbers
  { key: 'APHA', label: 'APHA number', icon: IMG_PATH + 'APHA-logo.png', category: 'Western' },
  { key: 'AQHA', label: 'AQHA number', icon: IMG_PATH + 'AQHA-logo.png', category: 'Western' },
  { key: 'ARHA', label: 'ARHA number', icon: IMG_PATH + 'ARHA-logo.png', category: 'Western' },
  { key: 'BBR', label: 'BBR number', icon: IMG_PATH + 'BBR-logo.png', category: 'Western' },
  { key: 'IBRA', label: 'IBRA number', icon: IMG_PATH + 'IBRA-logo.png', category: 'Western' },
  { key: 'NBHA', label: 'NBHA number', icon: IMG_PATH + 'NBHA-logo.png', category: 'Western' },
  { key: 'NCHA', label: 'NCHA number', icon: IMG_PATH + 'NCHA-logo.png', category: 'Western' },
  { key: 'NRCHA', label: 'NRCHA number', icon: IMG_PATH + 'NRCHA-logo.png', category: 'Western' },
  { key: 'NRHA', label: 'NRHA number', icon: IMG_PATH + 'NRHA-logo.png', category: 'Western' },
  { key: 'NSBA', label: 'NSBA number', icon: IMG_PATH + 'NSBA-logo.png', category: 'Western' },

  // Rodeo discipline numbers
  { key: 'APRA', label: 'APRA number', icon: IMG_PATH + 'APRA-logo.png', category: 'Rodeo' },
  { key: 'IPRA', label: 'IPRA number', icon: IMG_PATH + 'IPRA-logo.png', category: 'Rodeo' },
  { key: 'PBR', label: 'PBR number', icon: IMG_PATH + 'PBR-logo.png', category: 'Rodeo' },
  { key: 'PRCA', label: 'PRCA number', icon: IMG_PATH + 'PRCA-logo.png', category: 'Rodeo' },
  { key: 'WPRA', label: 'WPRA number', icon: IMG_PATH + 'WPRA-logo.png', category: 'Rodeo' },

  // College discipline numbers
  { key: 'IHSA', label: 'IHSA number', icon: IMG_PATH + 'IHSA-logo.png', category: 'College' },
  { key: 'NCEA', label: 'NCEA number', icon: IMG_PATH + 'NCEA-logo.png', category: 'College' },
  { key: 'NHSRA', label: 'NHSRA number', icon: IMG_PATH + 'NHSRA-logo.png', category: 'College' },
  { key: 'NIRA', label: 'NIRA number', icon: IMG_PATH + 'NIRA-logo.png', category: 'College' },
  { key: 'NLBR', label: 'NLBR number', icon: IMG_PATH + 'NLBR-logo.png', category: 'College' },

  // Other
  { key: 'OTHER', label: 'Other number', icon: '', category: 'Other' },
]

// USEF Report categorization - used for both riders and horses
export const BREED_AFFILIATE_FIELDS: string[] = [
  'IALHA',
  'AHA',
  'ACPS',
  'IFSHA',
  'AHHS',
  'AMHA',
  'NSHR',
  'PFHA',
  'ASHA',
  'ASPC',
  'WPCSA',
]

export const DISCIPLINE_AFFILIATE_FIELDS: string[] = [
  'USDF',
  'USEA',
  'UPHA',
  'USHJA',
  'EVUSA',
  'ARHPA',
  'WDAA',
  'AERC',
  'USPEA',
  'CAA',
]

// Helper functions to generate field names
function capitalizeFirstLetter(str: string): string {
  const lowerCaseStr = str.toLowerCase()
  return lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1)
}

// Generate TypeScript types from the constants
export type NumberMembershipFieldKey =
  | 'userACPS'
  | 'userAHA'
  | 'userAHHS'
  | 'userAMHA'
  | 'userARHPA'
  | 'userASHA'
  | 'userEVUSA'
  | 'userFEI'
  | 'userIALHA'
  | 'userIFSHA'
  | 'userNSHR'
  | 'userPFHA'
  | 'userUPHA'
  | 'userUSDF'
  | 'userUSEA'
  | 'userUSEF'
  | 'userUSHJA'
  | 'userWDAA'
  | 'userWPCSA'
  | 'userUSTA'
  | 'userEC'
  | 'userAPHA'
  | 'userAQHA'
  | 'userARHA'
  | 'userBBR'
  | 'userIBRA'
  | 'userNBHA'
  | 'userNCHA'
  | 'userNRCHA'
  | 'userNRHA'
  | 'userNSBA'
  | 'userAPRA'
  | 'userIPRA'
  | 'userPBR'
  | 'userPRCA'
  | 'userWPRA'
  | 'userIHSA'
  | 'userNCEA'
  | 'userNHSRA'
  | 'userNIRA'
  | 'userNLBR'

// Generate the NumberMembership type
export type NumberMembership = {
  [K in NumberMembershipFieldKey]?: IUserDocuments
}

// Generate user field names
export const getUserFieldName = (key: string): string => {
  return `user${key}`
}

// Generate horse field names
export const getHorseNumberFieldName = (key: string): string => {
  return `horse${capitalizeFirstLetter(key.toLowerCase())}Number`
}

export const getHorseExpirationFieldName = (key: string): string => {
  return `horse${capitalizeFirstLetter(key.toLowerCase())}Expiration`
}

export const getHorseImageFieldName = (key: string): string => {
  return `horse${capitalizeFirstLetter(key.toLowerCase())}Image`
}

// Filter by category helpers
export const getDisciplineFields = (category: DisciplineMembershipField['category']) => {
  return DISCIPLINE_MEMBERSHIP_FIELDS.filter((field) => field.category === category)
}

export const getAllDisciplineFields = () => DISCIPLINE_MEMBERSHIP_FIELDS
